import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext.js';

function BulkImportPage() {
    const { token } = useAuth();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadResult, setUploadResult] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setUploadResult(null);
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Please select a CSV file first.");
            return;
        }
        setIsUploading(true);
        setUploadResult(null);

        const formData = new FormData();
        formData.append('csvFile', selectedFile);

        try {
            const response = await fetch('https://members.abssvss.com/members_api/bulk_import_users.php', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || 'Upload failed.');
            setUploadResult(result);
        } catch (error) {
            setUploadResult({ error: error.message });
        } finally {
            setIsUploading(false);
            if(fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setSelectedFile(null);
        }
    };

    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-semibold text-gray-700">Bulk Import Members</h2>
            <div className="bg-gray-50 p-6 rounded-lg border border-dashed border-gray-300">
                <div className="text-sm text-gray-600 mb-4">
                    <p className="font-semibold">Instructions:</p>
                    <ul className="list-disc list-inside mt-1">
                        <li>Upload a CSV file with headers in this exact order: <code className="bg-gray-200 p-1 rounded text-xs">firstName,lastName,email,phoneNumber,state,city,position,joiningDate</code></li>
                        <li>The <code className="bg-gray-200 p-1 rounded text-xs">joiningDate</code> column should use the <strong className="text-brand-primary">DD-MM-YYYY</strong> format (e.g., 25-12-2023).</li>
                    </ul>
                </div>
                <div className="flex items-center gap-4">
                    <input 
                        type="file" 
                        accept=".csv" 
                        onChange={handleFileChange} 
                        ref={fileInputRef} 
                        className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"
                    />
                    <button 
                        onClick={handleUpload} 
                        disabled={isUploading || !selectedFile} 
                        className="bg-brand-primary hover:bg-red-900 text-white font-bold py-2 px-6 rounded-md disabled:bg-gray-400"
                    >
                        {isUploading ? 'Uploading...' : 'Upload'}
                    </button>
                </div>
                {uploadResult && (
                    <div className="mt-6 p-4 rounded-md bg-blue-50 text-blue-800 border border-blue-200">
                        <p className="font-bold">{uploadResult.message}</p>
                        {uploadResult.successCount !== undefined && <p>Successfully imported: {uploadResult.successCount}</p>}
                        {uploadResult.errorCount !== undefined && <p>Failed records: {uploadResult.errorCount}</p>}
                        {uploadResult.errors && uploadResult.errors.length > 0 && (
                            <div className="mt-2">
                                <p className="font-semibold">Error Details:</p>
                                <ul className="text-sm list-disc list-inside mt-1 max-h-40 overflow-y-auto">
                                    {uploadResult.errors.map((err, index) => <li key={index}>{err}</li>)}
                                </ul>
                            </div>
                        )}
                        {uploadResult.error && <p className="text-red-500 font-semibold">{uploadResult.error}</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BulkImportPage;

